<template>
  <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><circle cx="5" cy="13" r="1"/><circle cx="11" cy="19" r="1"/><circle cx="15" cy="25" r="1"/><circle cx="17" cy="15" r="1"/><circle cx="13" cy="11" r="1"/><circle cx="9" cy="27" r="1"/><circle cx="3" cy="21" r="1"/><path d="m25 30a4.9863 4.9863 0 0 1 -3-8.98v-6.02a3 3 0 0 1 6 0v6.02a4.9863 4.9863 0 0 1 -3 8.98zm0-16a1.0011 1.0011 0 0 0 -1 1v7.13l-.4971.2893a2.9676 2.9676 0 0 0 -1.5029 2.5807 3 3 0 0 0 6 0 2.9676 2.9676 0 0 0 -1.5029-2.5811l-.4971-.2889v-7.13a1.0011 1.0011 0 0 0 -1-1z"/><path d="m2 6h28v2h-28z"/><path d="m0 0h32v32h-32z" fill="none"/></svg>
</template>

<script>
export default {
  name: "SoilTempIcon",
};
</script>
